import React, { useEffect } from 'react';
import _ from 'lodash';
import Subject from './Subject';
import { useTranslation } from 'react-i18next';
import {
  ISubjectStateProps,
  ISubjectsStateProps,
  ISubjectsDispatchProps,
} from './constants';
import './Subjects.scss';

const Subjects: React.FC<ISubjectsStateProps & ISubjectsDispatchProps> = ({
  select,
  subjects,
  newExperiment,
}) => {
  const { t } = useTranslation();
  const elementRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const current = elementRef?.current;
    if (!current) {
      return;
    }
    const subject: ISubjectStateProps | undefined = _.find(
      subjects,
      (x) => x.selected
    );
    if (!subject) {
      return;
    }

    // In order to understand why this prefixed text `c` was added, please review Subject.tsx file comment.
    const component: HTMLElement | null | undefined =
      current.querySelector<HTMLElement>(`.c${subject.externalSubjectId}`);

    if (!component) {
      return;
    }

    component.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'nearest',
    });
  }, [subjects]);

  // generate subjects
  const generateSubjects = (): JSX.Element[] =>
    subjects.map((subject, idx) => {
      const config = {
        ...subject,
        select: () => select(subject),
        newExperiment: newExperiment,
      };
      return <Subject {...config} key={idx} />;
    });

  //generate table headers
  const generateTableHeaders = (
    <tr>
      <th>{t('upload_patientId', { uppercase: true })}</th>
      <th>{t('upload_sampleNameSampleType', { uppercase: true })}</th>
      <th>{t('upload_tagWell', { uppercase: true })}</th>
      {newExperiment ? (
        <th>{t('upload_mrdTestStatus', { uppercase: true })}</th>
      ) : null}
    </tr>
  );

  return (
    <div className='flowcells-data' ref={elementRef}>
      <table className='standard-table'>
        <thead>{generateTableHeaders}</thead>
        <tbody>{generateSubjects()}</tbody>
      </table>
    </div>
  );
};

export default Subjects;
